import { Injectable } from '@angular/core';
import { BarcodeScannedAction, ScannerFacade } from '../+state';
import { ScannerAdapterServiceBase } from './scanner-adapter.service.base';
import { AlertController } from '@ionic/angular';

@Injectable()
export class ScannerAdapterServiceMock extends ScannerAdapterServiceBase {
  private actionToDispatchOnBarcodeScanned: BarcodeScannedAction;

  constructor(private alertCtrl: AlertController, private scannerFacade: ScannerFacade) {
    super();
    this.actionToDispatchOnBarcodeScanned = null;
  }
  public async showScanner(actionToDispatchOnBarcodeScanned: BarcodeScannedAction) {
    this.actionToDispatchOnBarcodeScanned = actionToDispatchOnBarcodeScanned;
  }

  public closeScaner(): void {
    this.actionToDispatchOnBarcodeScanned = null;
  }

  public async startScanning() {
    await this.showScanBarcode();
  }

  public stopScanning(): void {}

  public async resumeScanning() {
    await this.showScanBarcode();
  }

  public pauseScanning(): void {}

  public changeMargins(): void {}

  private async showScanBarcode() {
    const alert = await this.alertCtrl.create({
      message: 'Please add the barcode',
      inputs: [
        {
          name: 'barcode',
          placeholder: 'Barcode',
        },
      ],
      buttons: [
        {
          text: 'Save',
          handler: (data) => {
            this.scannerFacade.barcodeScanned(data.barcode);
            this.scannerFacade.dispathCustomActionOnBarcodeScanned(this.actionToDispatchOnBarcodeScanned, data.barcode);
          },
        },
      ],
    });
    await alert.present();
  }
}
